<template>
  <div>
    <div v-if="isShow" class="width100 pa-tb-100 flex f-center f-jcenter">
      <div class="t-center ma-t-40">
        <img src="../img/empty.png" alt="" srcset="" width="200" />
        <div class="c-999 ma-t-20">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //是否显示
    isShow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.pa-tb-100{
  padding-top: 100px;
  padding-bottom: 100px;
}
</style>